import { render, staticRenderFns } from "./PublicationType.vue?vue&type=template&id=5d818ef2"
import script from "./PublicationType.vue?vue&type=script&lang=js"
export * from "./PublicationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports